import { useContext } from 'react';
import { RouterContext } from './router-context.context';

export const usePreviousLocation = () => {
  const routerContext = useContext(RouterContext);
  // `from` is the location prior to the current one, tracked by
  // RouterContextProvider's location effect. Read it live rather than freezing
  // `to` in a ref at first render: with code-split (React.lazy) pages the
  // consumer mounts after that effect has already advanced `to` to the current
  // location, so the old ref captured the current page and cancel/back buttons
  // navigated to themselves. See router-context.hooks.test.tsx.
  return routerContext.from;
};
